import React from "react";
import { Dropdown as PrimeDropdown } from "primereact/dropdown";

export interface DropdownOption {
  name: string;
  code: number | string;
}

interface DropdownProps {
  options: DropdownOption[];
  value: DropdownOption | null;
  onChange: (value: DropdownOption | null) => void;
  placeholder?: string;
  className?: string;
  searchable?: boolean;
}

const Dropdown: React.FC<DropdownProps> = ({
  options,
  value,
  onChange,
  placeholder = "Select",
  className,
  searchable = false,
}) => {
  return (
    <PrimeDropdown
      value={value}
      onChange={(e) => onChange(e.value)}
      options={options}
      optionLabel="name"
      placeholder={placeholder}
      className={className}
      filter={searchable}
      virtualScrollerOptions={
        options.length > 50 ? { itemSize: 38 } : undefined
      }
    />
  );
};

export default Dropdown;
